<template>
  <div class="mobile-help d-block d-sm-none">
    <div class="head-part">
      <router-link :to="{ name: 'profile' }" class="close-cls">
        <img src="/images/svg/global/left_arrow.svg" alt="" />
      </router-link>
      <h4>{{ _T('Help') }}</h4>
    </div>
    <div class="help-faq">
      <h4>{{ _T('Comming soon') }}...</h4>
    </div>
    <!-- <div class="search-sec">
      <input
        type="search"
        class="form-control"
        placeholder="Your question here..."
      />
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11Z"
          fill="#A19D97"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.9433 15.9433C16.3338 15.5528 16.967 15.5528 17.3575 15.9433L21.7075 20.2933C22.098 20.6838 22.098 21.317 21.7075 21.7075C21.317 22.098 20.6838 22.098 20.2933 21.7075L15.9433 17.3575C15.5528 16.967 15.5528 16.3338 15.9433 15.9433Z"
          fill="#A19D97"
          ></path>
      </svg>
    </div> -->
    <!-- <ul class="help-faq">
      <li data-toggle="modal" data-target="#helpFaq">
        Where can i see Homemade Food?
        <span
          ><img src="~assets/svg/global/right-small.svg" class="img-fluid" alt=""
        /></span>
      </li>
      <li data-toggle="modal" data-target="#helpFaq">
        How can i pay?
        <span
          ><img src="~assets/svg/global/right-small.svg" class="img-fluid" alt=""
        /></span>
      </li>
      <li data-toggle="modal" data-target="#helpFaq">
        How can fix issue?
        <span
          ><img src="~assets/svg/global/right-small.svg" class="img-fluid" alt=""
        /></span>
      </li>
    </ul> -->
    <div class="contact_bottom">
      <h6>{{ _T('Still need help') }}?</h6>
      <router-link :to="{ name: 'contact_us' }" class="btn btn-solid">
        {{ _T('Contact Us') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Help',
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss" scoped>
.mobile-help {
  .head-part {
    position: relative;
    padding: $px10 $px60;
    h4 {
      font-weight: bold;
      font-size: $px18;
      line-height: $px22;
      color: $font-color;
      text-transform: capitalize;
      margin-bottom: 0;
    }
    .close-cls {
      position: absolute;
      left: $px20;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
    }
  }
  .help-faq {
    h4 {
      font-weight: 600;
      font-size: $px14;
      line-height: $px17;
      letter-spacing: 0.02em;
      color: $font-color;
      padding: $px20;
      width: 100%;
      display: block;
      position: relative;
      border-bottom: $px1 solid $light-border;
    }
  }
  .contact_bottom {
    display: flex;
    align-items: center;
    padding: $px15 $px20;
    border-top: $px1 dashed $light-border;
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: $white;
    z-index: 1111;
    h6 {
      font-weight: bold;
      font-size: $px14;
      line-height: $px17;
      letter-spacing: 0.02em;
      color: $font-color;
      margin-bottom: 0;
    }
    .btn {
      padding: $px13 $px24;
      margin-left: auto;
    }
  }
}
</style>
